import React, { useContext, useState } from 'react';
import styled from 'styled-components/native';
// import styled from 'styled-components';
import { Link } from 'app/src/utils/routing';

import AuthContext from '../../contexts/AuthContext';
import { buttonBackground } from '../../styles/colors';
import { View, Pressable, Text } from 'react-native';
import Account from '.';
import Modal from 'app/src/elements/Modal';
import NewTroubleTicket from '../TroubleTickets/new';
import { createPortal } from 'react-dom';
import UserContext from '../../contexts/UserContext';
import ClickOutside from '../../elements/ClickListener';

const Dropdown = styled(View)`
  z-index: 9999;
  position: absolute;
  width: 300px;
  right: ${props => props.screenWidth < 600 ? '80px' : props.screenWidth < 992 ? '180px' : '10px'};
  top: ${props => props.screenWidth < 600 ? '350px' : props.screenWidth < 992 ? '350px' : '80px'};
  background-color: white;
  border: 1px solid ${buttonBackground};
  border-radius: 6px;
  padding: 12px;

  @media (max-width: 768px) {
    top: 180px;
  }
`;

const LinkContainer = styled(View)`
  display: flex;
`;

const AccountMenu = ({ showMenu, setShowMenu }) => {
  const { clearCredentials } = useContext(AuthContext);
  const [showEditAccountModal, setShowEditAccountModal] = useState();
  const [showTroubleTicketModal, setShowTroubleTicketModal] = useState();
  const { screenWidth } = useContext(UserContext);

  return (
    <>
      {showMenu && (
        createPortal(
          <Dropdown screenWidth={screenWidth}>
            <ClickOutside
              onClick={() => {
                setShowMenu(false);
              }}
              className={'header-navigation-links'}
            >

              <LinkContainer id="account-menu">
                <Pressable onPress={() => setShowEditAccountModal(true)}>
                  <Text id='sub-link'>Update Account/Password</Text>
                </Pressable>
                <br />
                <Pressable
                  onPress={() => setShowTroubleTicketModal(true)}
                >
                  <Text id='sub-link'>Trouble Ticket</Text>
                </Pressable>
                <br />
                <Pressable
                  onPress={() => clearCredentials()}
                >
                  <Text id='sub-link'>
                    Logout
                  </Text>
                </Pressable>
              </LinkContainer>
            </ClickOutside>
          </Dropdown>, document.body
        )
      )}
      {showEditAccountModal &&
        <Modal
          showModal={showEditAccountModal}
          setShowModal={setShowEditAccountModal}
          modalType={'Edit Account'}
        >
          <Account
            setShowModal={setShowEditAccountModal}
          />
        </Modal>
      }
      {showTroubleTicketModal &&
        <Modal
          showModal={showTroubleTicketModal}
          setShowModal={setShowTroubleTicketModal}
          modalType={'Create Trouble Ticket'}
        >
          <NewTroubleTicket
            setShowModal={setShowTroubleTicketModal}
          />
        </Modal>
      }
    </>
  )
};

export default AccountMenu;
